/* eslint-disable react/jsx-key */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import {
  Button,
  Radio,
  Select,
  DatePicker as DatePickerControl,
  // Spin,
  Checkbox,
  message,
  Dropdown,
  Menu,
  //  List,
  Tag,
  // Tabs,
  Divider,
  InputNumber,
} from 'antd'
import {
  DatePicker,
  // Overlay,
  GenericModal,
  getApiTargetInfo,
  // UnitSelection,
  // StationSelection,
} from 'core'
import { SpinContext, ErrorContext, DatePickerContext } from 'context'
import {
  getHrsInDay,
  getUnits,
  getUtilityNameMap,
  getEventTypes,
  getStations,
  getUtilityStationMap,
  getPermitActions,
  getEnvConfig,
  getReportNameMap,
  getReportDisplayCodeMap,
  getUserReport,
  getUserRoleType,
  getUserCompany,
  getUserStation,
  getCompanyUtilityMap,
  getUnitNameMap,
  getCauseCodeMap,
  getStationUtilityMap,
  getUtilityUnitsMap,
  getUnitTypeCode,
} from 'core/selectors'
import { getChangeDateSelectionProps } from './dm/changeDateSelection'
import {
  getCauseCodeAll,
  // getHeInDay,
  // getReportMaGroups,
  // getGorpIrmb,
  // getReportWindSelection,
  // getRegion,
  // getRiverRegionGroup,
  // getSystemConfigurationInfo,
  // getRiverUnitGroup,
  // getJasperReports,
  getReportInitLoad,
} from 'api/pgads'
import { setTransDate } from 'core/actions'
import { connect } from 'react-redux'
import moment from 'moment'
import R from 'ramda'

import {
  visibleCompoValues,
  getVisibilityStatusPrReport2,
} from './dm/reportVisibleStatus2'

import callReport, { getDate } from './dm/reportCall'
import styled from 'styled-components'
import { Content, FullHeightSizer } from 'core/screen-util'

import SelectUnit from './components/SelectUnits'
import SelectStation from './components/SelectStation'
import CauseCodePrompt from 'card-data/MultiCauseCode'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits, sortStringArray } from 'core/utils'
import JcTmpErrorContext from 'context/JcTmpErrorContext'
import { getClientInfo } from '../core/selectors'
import {
  AEPREG_CLIENT,
  AEPUNREG_CLIENT,
  BROOKFIELD_CLIENT,
  NYISO_CLIENT,
} from 'client'
import EventExcludes from './components/EventsExcludes'
import { TVA_CLIENT } from '../client'
import { UnitSelectionContext } from 'context/UnitSelectionContext'

// const Container = styled.div`
//   margin: 10px 10px 0px 10px;
// `

const inlineStyle = {
  // marginLeft: '10px',
}

const LabelBold = styled.label`
  font-weight: bold;
  display: grid;
`

const TD = styled.td`
  padding: 10px;
  //border: 1px solid black;
`
const TR = styled.tr`
  padding: 10px;
`
// const Table = styled.table`
//   padding: 10px;
// `

const JasperReportMap = [
  { REPORTFORMAT: 'RPT_OUTPUT_CSV', display: ' Jasper CSV Format' },
  { REPORTFORMAT: 'RPT_OUTPUT_PDF', display: ' Jasper PDF Format' },
  { REPORTFORMAT: 'RPT_OUTPUT_XLS', display: ' Jasper XLS Format' },
  { REPORTFORMAT: 'RPT_OUTPUT_HTML', display: ' Jasper HTML Format' },
]

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  endDateHourList: getHrsInDay(state),
  utility: getUtilityNameMap(state),
  units: getUnits(state),
  eventTypes: getEventTypes(state),
  stations: getStations(state),
  utilityStation: getUtilityStationMap(state),

  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  userReports: getUserReport(state),
  reportNameMap: getReportNameMap(state),
  reportDisplayCodeMap: getReportDisplayCodeMap(state),
  userRoleType: getUserRoleType(state),
  userCompany: getUserCompany(state),
  userStation: getUserStation(state),
  companyUtilityMap: getCompanyUtilityMap(state),
  unitNameMap: getUnitNameMap(state),
  CLIENT: getClientInfo(state),
  causeCodeMap: getCauseCodeMap(state),
  stationUtilityMap: getStationUtilityMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  unitTypeCodes: getUnitTypeCode(state),
})

const convertHourToObject = add => d =>
  d.map((d, i) => ({ value: i + add, text: `${d}` }))

class Report extends React.Component {
  setReportMessage = reportMessage => this.setState({ reportMessage })

  onCauseCodeTreeCancel = defaultExpandedKeys =>
    this.setState({ causeCodeDialogVisible: false, defaultExpandedKeys })

  componentDidUpdate() {
    this.rptNames =
      this.props.userReports
        .map(i => ({
          id: i,
          name: this.props.reportNameMap[i],
          displayCode: this.props.reportDisplayCodeMap[i],
        }))
        .filter(r => r.displayCode !== '000000000000000')
        .filter(r => r.id !== undefined && r.name !== undefined) || []
  }

  componentDidMount() {
    this.rptNames =
      this.props.userReports
        .map(i => ({
          id: i,
          name: this.props.reportNameMap[i],
          displayCode: this.props.reportDisplayCodeMap[i],
        }))
        .filter(r => r.displayCode !== '000000000000000')
        .filter(r => r.id !== undefined && r.name !== undefined) || []
    this.rptNames = R.sortBy(a => a.name)(this.rptNames || [])

    getReportInitLoad(this.props.targetInfo).fork(
      _ => {
        this.windSubgroupIdNameMap = {}
        this.windUtilityIdNameMap = {}
        this.windUtilitySubgroup = {}
        this.setState({
          avaliableGorpIRMB: false,
          maGroupList: [],
          selMaGroup: [],
          regionList: [],
          riverRegionList: [],
          riverUnitgroup: [],
          defaultNercPjm: '1',
          typeBy: '1',
          jasperReportList: [],
        })
      },

      allData => {
        const {
          hours,
          gorpIrmb,
          maGroup,
          region,
          riverRegionGroup,
          riverUnitGroup,
          systemconfiguration,
          windSelection,
          jasperReport,
          aepAcaReportUnitIds,
        } = allData

        const defaultType = systemconfiguration.find(
          f => f.key === 'DEFAULT_NERC_PJM'
        )
        const defauktlVal =
          defaultType && defaultType.value === 'NERC'
            ? { defaultNercPjm: '2', typeBy: '2' }
            : { defaultNercPjm: '1', typeBy: '1' }

        const red = (a, b) => ({ ...a, ...b })
        this.windUtilityIdNameMap = R.reduce(
          red,
          {},
          windSelection.map(d => ({ [d.utility]: d.utilityName }))
        )
        this.windSubgroupIdNameMap = R.reduce(
          red,
          {},
          windSelection.map(d => ({ [d.subgroupId]: d.subgroupName }))
        )
        this.windUtilitySubgroup = R.groupBy(
          R.prop('utility')
          // R.prop('subgroupId')
        )(windSelection)
        this.windUtilitySubgroup = R.reduce(
          red,
          {},
          Object.keys(this.windUtilitySubgroup).map(k => ({
            [k]: this.windUtilitySubgroup[k].map(r => r.subgroupId),
          }))
        )

        this.setState({
          startHourList: hours,
          avaliableGorpIRMB: gorpIrmb.GORP === 'YES',
          maGroupList: sortStringArray(maGroup),
          selMaGroup: [],
          regionList: region,
          riverRegionList: riverRegionGroup,
          riverUnitgroup: riverUnitGroup,
          ...defauktlVal,
          jasperReportList: jasperReport,
          aepAcaReportUnitIds,
        })
      }
    )
    getCauseCodeAll(this.props.targetInfo).fork(
      _ => _,
      cl => this.setState({ causeCodeList: cl })
    )

    // getHeInDay(this.props.targetInfo)(this.state.startDate).fork(
    //   _ => _,
    //   d => this.setState({ startHourList: d })
    // )
    // getGorpIrmb(this.props.targetInfo).fork(
    //   _ => this.setState({ avaliableGorpIRMB: false }),
    //   d => {
    //     d.GORP === 'YES' && this.setState({ avaliableGorpIRMB: true })
    //   }
    // )
    // getReportMaGroups(this.props.targetInfo).fork(
    //   _ => this.setState({ maGroupList: [], selMaGroup: [] }),
    //   data => {
    //     this.setState({ maGroupList: data, selMaGroup: [] })
    //   }
    // )
    // getRegion(this.props.targetInfo).fork(
    //   _ => _,
    //   regionList => this.setState({ regionList })
    // )
    // getRiverRegionGroup(this.props.targetInfo)(moment()).fork(
    //   _ => _,
    //   riverRegionList => this.setState({ riverRegionList })
    // )

    // getRiverUnitGroup(this.props.targetInfo)(moment()).fork(
    //   _ => _,
    //   riverUnitgroup => {
    //     this.setState({ riverUnitgroup })
    //   }
    // )

    // getSystemConfigurationInfo(this.props.targetInfo).fork(
    //   _ => {
    //     this.setState({ defaultNercPjm: '1', typeBy: '1' })
    //   },
    //   data => {
    //     const defaultType = data.find(f => f.key === 'DEFAULT_NERC_PJM')
    //     if (defaultType && defaultType.value === 'NERC')
    //       this.setState({ defaultNercPjm: '2', typeBy: '2' })
    //     else this.setState({ defaultNercPjm: '1', typeBy: '1' })
    //   }
    // )

    // getReportWindSelection(this.props.targetInfo).fork(
    //   _ => {
    //     // this.setState({ windUtility: [], windSubgroup: [] })
    //     this.windSubgroupIdNameMap = {}
    //     this.windUtilityIdNameMap = {}
    //     this.windUtilitySubgroup = {}
    //   },
    //   data => {
    //     const red = (a, b) => ({ ...a, ...b })
    //     this.windUtilityIdNameMap = R.reduce(
    //       red,
    //       {},
    //       data.map(d => ({ [d.utility]: d.utilityName }))
    //     )
    //     this.windSubgroupIdNameMap = R.reduce(
    //       red,
    //       {},
    //       data.map(d => ({ [d.subgroupId]: d.subgroupName }))
    //     )
    //     this.windUtilitySubgroup = R.groupBy(
    //       R.prop('utility')
    //       // R.prop('subgroupId')
    //     )(data)
    //     this.windUtilitySubgroup = R.reduce(
    //       red,
    //       {},
    //       Object.keys(this.windUtilitySubgroup).map(k => ({
    //         [k]: this.windUtilitySubgroup[k].map(r => r.subgroupId),
    //       }))
    //     )

    //   }
    // )

    // getJasperReports(this.props.targetInfo).fork(
    //   _ => this.setState({ jasperReportList: [] }),
    //   jasperReportList => {
    //     this.setState({ jasperReportList })
    //   }
    // )
  }

  changeReportName(reportId) {
    const reportName = this.props.reportNameMap[reportId]
    const omcBefore = moment('2006-01-01').isBefore(
      moment(getDate(this.state).startDate, 'MM/DD/YYYY')
    )
    const final = getVisibilityStatusPrReport2(
      reportId,
      this.props.reportDisplayCodeMap,
      this.props.reportNameMap,
      omcBefore,
      this.props.CLIENT,
      this.state
    )
    let selUtility = []
    let selUnits = []
    let setUnitUtility = this.state.setUnitUtility || []
    if (final.visibleUnit) {
      selUnits = setUnitUtility.map(d => d.unit)
      selUtility = setUnitUtility.map(d => d.utility)
    } else if (final.visibleWindSubgroupSelection) {
      selUtility = (this.state.windSelection || []).map(w =>
        w.substr(0, w.indexOf('-'))
      )
      selUnits = (this.state.windSelection || []).map(w =>
        w.substr(w.indexOf('-') + 1)
      )
    } else {
      selUtility = this.state.selUtilityStation || []
    }

    // const selectionDisplayTab = !final.visibleStation
    //   ? 'unit'
    //   : this.state.selectionDisplayTab || 'station'
    const selectionDisplayTab = final.visibleUnit ? 'unit' : 'station'
    const hasJasperPermission = !!(this.state.jasperReportList || []).find(
      f => f.reportId === reportId
    )

    if (
      (this.props.CLIENT === AEPREG_CLIENT ||
        this.props.CLIENT === AEPUNREG_CLIENT) &&
      reportId === '205'
    ) {
      const selUl = setUnitUtility.filter(f =>
        this.state.aepAcaReportUnitIds.includes(f.unitId)
      )

      selUnits = selUl.map(d => d.unit)
      selUtility = selUl.map(d => d.utility)
      setUnitUtility = selUl
      this.props.setSelectedUnits(setUnitUtility)
    }

    this.setState({
      hasJasperPermission,
      selectionDisplayTab,
      reportId,
      omcBefore,
      selectedReportName: reportName,
      actionName: `view_report_${reportName}`,
      ...final,
      selUnits,
      selUtility,
      setUnitUtility,
      reportDisplayCodeMap: this.props.reportDisplayCodeMap,
      reportNameMap: this.props.reportName,
    })
  }

  getRiverByStation(riverUnitGroup, selUtilityStation) {
    const units = this.props.units
    const selUnitsByStation = R.compose(
      R.uniq,
      R.map(({ unitId }) => unitId),
      R.filter(({ station }) => {
        return selUtilityStation.includes(station)
      })
    )(units)

    const selRiverByStation = R.compose(
      R.sort(sortStringArray),
      R.uniq,
      R.map(r => r.river),
      R.flatten,
      R.map(unitId => {
        return riverUnitGroup.filter(({ units }) => units.includes(unitId))
      })
    )(selUnitsByStation)

    return selRiverByStation
  }

  getStationByRiver(selectedRiver = [], riverUnitGroup = []) {
    const unitsByRiver = R.compose(
      R.uniq,
      R.flatten,
      R.map(rm => rm.units || []),
      R.filter(({ river }) => selectedRiver.includes(river))
    )(riverUnitGroup)

    const units = this.props.units

    const stationByRiverUnits = R.compose(
      // R.isNotNil,
      R.uniq,
      R.filter(f => !R.isNil(f)),
      R.map(u => u.station),
      R.filter(({ unitId }) => unitsByRiver.includes(unitId))
    )(units)

    return stationByRiverUnits
  }

  getRegionList() {
    return R.compose(
      sortStringArray,
      R.uniq,
      R.map(r => r.region)
      // R.flatten,
      // R.map(r => {
      //   return riverRegionList.filter(({ river }) => river.includes(r))
      // })
    )(this.state.regionList || [])
  }

  getRiverListByRegion() {
    return R.compose(
      sortStringArray,
      // R.filter(r =>
      //   (selectedRiverList || []).includes(r)
      // ),
      R.uniq,
      R.flatten,
      R.map(r => r.river || []),
      R.filter(r => (this.state.region || []).includes(r.region))
    )(this.state.riverRegionList || [])
  }

  getDateMap(key) {
    return key.includes('s')
      ? this.state.dateMapStart && this.state.dateMapStart[key]
      : this.state.dateMapEnd && this.state.dateMapEnd[key]
  }

  setDateMap(date, key) {
    key.includes('s')
      ? this.setState({
          dateMapStart: {
            ...this.state.dateMapStart,
            [key]: date,
            ['c' + key]: date && date.format('MM/DD/YYYY'),
          },
        })
      : this.setState({
          dateMapEnd: {
            ...this.state.dateMapEnd,
            [key]: date,
            ['c' + key]: date && date.format('MM/DD/YYYY'),
          },
        })
  }

  render() {
    const sortCauseCodeData =
      R.compose(
        R.sort((a, b) => a - b),
        R.map(id => parseInt(id)),
        R.map(r => r.causeCode)
      )(this.state.causeCodeValues || []) || []

    const riverByRegion = this.getRiverListByRegion()
    const stationByRiverUnit = this.getStationByRiver(
      this.state.river,
      this.state.riverUnitgroup
    )

    return (
      <>
        {this.state.causeCodeDialogVisible && (
          <CauseCodePrompt
            // unitCodes={['CG', 'CC']}
            unitCodes={
              (this.state.setUnitUtility || []).length <= 0
                ? Object.keys(this.props.unitTypeCodes)
                : R.uniq(
                    (this.state.setUnitUtility || [])
                      .filter(f => !!f.id1)
                      .map(u => u.id1)
                  )
            }
            key="reportmaincausecodeprompt"
            // style={{ ...inlineStyle }}
            // checkable={false}
            visibleDialog={this.state.causeCodeDialogVisible}
            onDialogClose={this.onCauseCodeDialogClose}
            onCancelAction={this.onCauseCodeTreeCancel}
            // defaultExpandedKeys={
            //   this.state.causeCode ? this.state.causeCode.selectedKeys : []
            // }
            defaultExpandedKeys={this.state.causeCodeKeyValues}
            defaultCheckedKeys={this.state.causeCodeKeyValues}
            // unitCode={this.state.unitCodeMap && this.state.unitCodeMap[selectedUnits[0]]}
            // unitCode={
            //   this.state.unitCodeMap &&
            //   this.state.unitCodeMap[
            //     selectedUnits && selectedUnits[0] ? selectedUnits[0].unitId : 'CC'
            //   ]
            // }
            multiple
            checkable
            selectable={false}
            causeCodeValue={
              this.state.causeCodeValues.map(c => c.causeCode) || []
            }
            causeCodeList={this.state.causeCodeList}
            selectedKeys={this.state.causeCodeKeyValues || []}
            selectedValues={this.state.causeCodeValues || []}
          />
        )}

        {this.state.reportMessage && (
          <GenericModal
            key="msg"
            title="Message"
            size="small"
            open
            onClose={() => {
              this.setState({ reportMessage: undefined })
            }}
          >
            {() => this.state.reportMessage}
          </GenericModal>
        )}
        <FullHeightSizer heightOffset={160}>
          {({ height }) => (
            <Content style={{ margin: '5px', height: height }}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'auto min-content 250px',
                  gridColumnGap: '5px',
                }}
              >
                <div style={{ maxHeight: '700px', overflowY: 'auto' }}>
                  <table cellPadding="10" rowpadding="10">
                    <tr>
                      <td>
                        <LabelBold style={{ ...inlineStyle }}>
                          Report Name :
                        </LabelBold>
                      </td>
                    </tr>
                    <TR>
                      <td colSpan={2}>
                        <Select
                          onChange={value => this.changeReportName(value)}
                          style={{ ...inlineStyle, width: '100%' }}
                          value={this.state.reportId}
                          // onSearch={(value = '') => {
                          //   return this.rptNames.filter(f =>
                          //     f.name.toLowerCase().includes(value.toLowerCase())
                          //   )
                          // }}
                          showSearch
                          filterOption={(inputValue, option) => {
                            return (
                              (option.key || '')
                                // .join('')
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            )
                          }}
                        >
                          {/* {
                        this.props.userReports.map(i=>({id:i,name:this.props.reportNameMap[i]}))
                    } */}
                          {R.sortBy(a => a.name)(this.rptNames || []).map(
                            ({ id, name }) => (
                              <Select.Option id={id} value={id} key={id + name}>
                                {name}
                              </Select.Option>
                            )
                          )}
                        </Select>
                      </td>
                      <td style={{}}>
                        <Dropdown
                          overlay={_ => (
                            <Menu>
                              <Menu.Item
                                icon="file-pdf"
                                disabled={!this.state.visiblePDFButton}
                                onClick={() => {
                                  callReport(
                                    this.props.targetInfo,
                                    {
                                      ...this.state,
                                      endDate: this.state.endDate,
                                      REPORTFORMAT: 'RPT_OUTPUT_PDF',
                                      BACKGROUND: false,
                                      setLoading: this.props.setLoading,
                                      setReportMessage: this.setReportMessage,
                                      setErr: this.props.setError,
                                      setTmpError: this.props.setTmpError,
                                    },
                                    this.props.eventTypes
                                  )
                                }}
                              >
                                PDF Format
                              </Menu.Item>
                              <Menu.Item
                                icon="file-excel"
                                disabled={!this.state.visibleCSVButton}
                                onClick={() => {
                                  callReport(
                                    this.props.targetInfo,
                                    {
                                      ...this.state,
                                      endDate: this.state.endDate,
                                      REPORTFORMAT: 'RPT_OUTPUT_CSV',
                                      BACKGROUND: false,
                                      setLoading: this.props.setLoading,
                                      setReportMessage: this.setReportMessage,
                                      setErr: this.props.setError,
                                      setTmpError: this.props.setTmpError,
                                    },
                                    this.props.eventTypes
                                  )
                                  // if (isValid) {
                                  //   message.info(
                                  //     'The Report has been quiued to run in backGround',
                                  //     10
                                  //   )
                                  //   message.info(
                                  //     'Please Run Completed Reports screen to retrieve report.',
                                  //     10
                                  //   )
                                  // }
                                }}
                              >
                                CSV Format
                              </Menu.Item>
                              {this.state.visibleExcelButton && (
                                <Menu.Item
                                  icon="file-excel"
                                  disabled={!this.state.visibleExcelButton}
                                  onClick={() => {
                                    callReport(
                                      this.props.targetInfo,
                                      {
                                        ...this.state,
                                        endDate: this.state.endDate,
                                        REPORTFORMAT: 'RPT_OUTPUT_CSV',
                                        BACKGROUND: false,
                                        setLoading: this.props.setLoading,
                                        setReportMessage: this.setReportMessage,
                                        setErr: this.props.setError,
                                        setTmpError: this.props.setTmpError,
                                      },
                                      this.props.eventTypes
                                    )
                                    // if (isValid) {
                                    //   message.info(
                                    //     'The Report has been quiued to run in backGround',
                                    //     10
                                    //   )
                                    //   message.info(
                                    //     'Please Run Completed Reports screen to retrieve report.',
                                    //     10
                                    //   )
                                    // }
                                  }}
                                >
                                  Excel Format
                                </Menu.Item>
                              )}
                              {this.REPORT_EXCEL_PERMISSION && (
                                <Menu.Item
                                  icon="file-excel"
                                  onClick={() => {
                                    callReport(
                                      this.props.targetInfo,
                                      {
                                        ...this.state,
                                        endDate: this.state.endDate,
                                        REPORTFORMAT: 'RPT_OUTPUT_EXCEL',
                                        BACKGROUND: false,
                                        setLoading: this.props.setLoading,
                                        setReportMessage: this.setReportMessage,
                                        setErr: this.props.setError,
                                        setTmpError: this.props.setTmpError,
                                      },
                                      this.props.eventTypes
                                    )
                                  }}
                                >
                                  Excel Format
                                </Menu.Item>
                              )}
                              {this.REPORT_JASPER_PERMISSION &&
                                JasperReportMap.map(js => (
                                  <Menu.Item
                                    icon="file-pdf"
                                    disabled={!this.state.hasJasperPermission}
                                    onClick={() => {
                                      callReport(
                                        this.props.targetInfo,
                                        {
                                          ...this.state,
                                          jasper: true,
                                          endDate: this.state.endDate,
                                          // REPORTFORMAT: 'RPT_OUTPUT_PDF', //works
                                          REPORTFORMAT: js.REPORTFORMAT, // this has depd issue
                                          // REPORTFORMAT: 'RPT_OUTPUT_HTML', //works
                                          // REPORTFORMAT: 'RPT_OUTPUT_CSV',// works
                                          BACKGROUND: false,
                                          setLoading: this.props.setLoading,
                                          setReportMessage: this
                                            .setReportMessage,
                                          setErr: this.props.setError,
                                          setTmpError: this.props.setTmpError,
                                        },
                                        this.props.eventTypes
                                      )
                                    }}
                                  >
                                    {js.display}
                                  </Menu.Item>
                                ))}
                            </Menu>
                          )}
                        >
                          <Button
                            icon="audit"
                            type="primary"
                            style={{
                              ...inlineStyle,
                              // width: '100%',
                              width: '250px',
                            }}
                          >
                            Generate Report
                          </Button>
                        </Dropdown>
                      </td>

                      <td colSpan={1} style={{ minWidth: '150px' }}>
                        {this.state.visibleBackgroundButton && (
                          <Dropdown
                            overlay={_ => (
                              <Menu>
                                <Menu.Item
                                  icon="file-pdf"
                                  disabled={!this.state.visiblePDFButton}
                                  onClick={() => {
                                    const isValid = callReport(
                                      this.props.targetInfo,
                                      {
                                        ...this.state,
                                        endDate: this.state.endDate,
                                        REPORTFORMAT: 'RPT_OUTPUT_PDF',
                                        BACKGROUND: true,
                                        setLoading: this.props.setLoading,
                                        setReportMessage: this.setReportMessage,
                                        setErr: this.props.setError,
                                        setTmpError: this.props.setTmpError,
                                      },
                                      this.props.eventTypes
                                    )
                                    if (isValid) {
                                      message.info(
                                        'The Report has been queued to run in background',
                                        5
                                      )
                                      message.info(
                                        'Please Run Completed Reports screen to retrieve report.',
                                        5
                                      )
                                    }
                                  }}
                                >
                                  PDF Format
                                </Menu.Item>
                                <Menu.Item
                                  icon="file-excel"
                                  disabled={!this.state.visibleCSVButton}
                                  onClick={() => {
                                    const isValid = callReport(
                                      this.props.targetInfo,
                                      {
                                        ...this.state,
                                        endDate: this.state.endDate,
                                        REPORTFORMAT: 'RPT_OUTPUT_CSV',
                                        BACKGROUND: true,
                                        setLoading: this.props.setLoading,
                                        setReportMessage: this.setReportMessage,
                                        setErr: this.props.setError,
                                        setTmpError: this.props.setTmpError,
                                      },
                                      this.props.eventTypes
                                    )
                                    if (isValid) {
                                      message.info(
                                        'The Report has been queued to run in background',
                                        3
                                      )
                                      message.info(
                                        'Please Run Completed Reports screen to retrieve report.',
                                        3
                                      )
                                    }
                                  }}
                                >
                                  CSV Format
                                </Menu.Item>

                                {this.REPORT_JASPER_PERMISSION &&
                                  JasperReportMap.map(js => (
                                    <Menu.Item
                                      icon="file-pdf"
                                      disabled={!this.state.hasJasperPermission}
                                      onClick={() => {
                                        const isValid = callReport(
                                          this.props.targetInfo,
                                          {
                                            ...this.state,
                                            jasper: true,
                                            endDate: this.state.endDate,
                                            // REPORTFORMAT: 'RPT_OUTPUT_PDF', //works
                                            REPORTFORMAT: js.REPORTFORMAT, // this has depd issue
                                            // REPORTFORMAT: 'RPT_OUTPUT_HTML', //works
                                            // REPORTFORMAT: 'RPT_OUTPUT_CSV',// works
                                            BACKGROUND: true,
                                            setLoading: this.props.setLoading,
                                            setReportMessage: this
                                              .setReportMessage,
                                            setErr: this.props.setError,
                                            setTmpError: this.props.setTmpError,
                                          },
                                          this.props.eventTypes
                                        )
                                        if (isValid) {
                                          message.info(
                                            'The Report has been queued to run in background',
                                            3
                                          )
                                          message.info(
                                            'Please Run Completed Reports screen to retrieve report.',
                                            3
                                          )
                                        }
                                      }}
                                    >
                                      {js.display}
                                    </Menu.Item>
                                  ))}
                              </Menu>
                            )}
                          >
                            <Button
                              icon="robot"
                              type="primary"
                              style={{ ...inlineStyle, marginLeft: '10px' }}
                            >
                              Generate Report in Background
                            </Button>
                          </Dropdown>
                        )}
                      </td>
                      <TD>
                        <div style={{ minWidth: '100px' }} />
                      </TD>
                    </TR>
                    <tr>
                      <td colSpan={5} style={{ padding: '0px' }}>
                        <Divider style={{ margin: '3px', padding: '0px' }} />
                      </td>
                    </tr>

                    {this.state.visibleRegionriverStationcodeSelection && (
                      <TR>
                        <td colSpan="4" style={{}}>
                          <div
                            style={{
                              maxWidth: 'fit-content',
                              minWidth: '100%',
                            }}
                          >
                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '100px auto',
                              }}
                            >
                              <LabelBold style={{ ...inlineStyle }}>
                                Region :
                              </LabelBold>
                              <Checkbox
                                checked={this.state.regioncheckedAll === true}
                                onChange={e => {
                                  const checked = e.target.checked
                                  this.setState({
                                    regioncheckedAll: checked,
                                    region: checked ? this.getRegionList() : [],
                                    selStations: [],
                                    selUtilityStation: [],
                                  })
                                }}
                              >
                                Select All
                              </Checkbox>
                            </div>
                            <Select
                              style={{ ...inlineStyle, width: '100%' }}
                              value={this.state.region}
                              onChange={value => {
                                value.includes('All')
                                  ? this.setState({
                                      region: this.getRegionList(),
                                      rivercheckedAll: false,
                                      regioncheckedAll: false,
                                      selStations: [],
                                      selUtilityStation: [],
                                    })
                                  : this.setState({
                                      region: value,
                                      river: [],
                                      rivercheckedAll: false,
                                      regioncheckedAll: false,
                                      selStations: [],
                                      selUtilityStation: [],
                                    })
                              }}
                              mode="multiple"
                              disabled={
                                !this.state
                                  .visibleRegionriverStationcodeSelection
                              }
                            >
                              {/* <Select.Option value="All">All</Select.Option> */}
                              {this.getRegionList().map(d => (
                                <Select.Option value={d}>{d}</Select.Option>
                              ))}
                            </Select>
                          </div>
                        </td>
                      </TR>
                    )}
                    {this.state.visibleRegionriverStationcodeSelection && [
                      <TR>
                        <td colSpan="4" style={{}}>
                          <div
                            style={{
                              maxWidth: 'fit-content',
                              minWidth: '100%',
                            }}
                          >
                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '100px auto',
                              }}
                            >
                              <LabelBold style={{ ...inlineStyle }}>
                                River :
                              </LabelBold>
                              <Checkbox
                                checked={this.state.rivercheckedAll === true}
                                onChange={e => {
                                  const checked = e.target.checked
                                  this.setState({
                                    rivercheckedAll: checked,
                                    river: checked ? riverByRegion : [],
                                    selStations: [],
                                    selUtilityStation: [],
                                  })
                                }}
                              >
                                Select All
                              </Checkbox>
                            </div>
                            <Select
                              // key={(this.state.region || []).length}
                              style={{ ...inlineStyle, width: '100%' }}
                              value={this.state.river}
                              onChange={river => {
                                river.includes('All')
                                  ? this.setState({
                                      river: riverByRegion,
                                      selStations: [],
                                      selUtilityStation: [],
                                    })
                                  : this.setState({
                                      river,
                                      selStations: [],
                                      selUtilityStation: [],
                                    })
                              }}
                              mode="multiple"
                              disabled={
                                !this.state
                                  .visibleRegionriverStationcodeSelection
                              }
                            >
                              {/* <Select.Option value="All">All</Select.Option> */}
                              {R.compose(
                                R.map(r => (
                                  <Select.Option value={r} key={r}>
                                    {r}
                                  </Select.Option>
                                ))
                              )(riverByRegion || [])}
                            </Select>
                          </div>
                        </td>
                      </TR>,
                      <tr>
                        <td colSpan={5} style={{ padding: '0px' }}>
                          <Divider style={{ margin: '3px', padding: '0px' }} />
                        </td>
                      </tr>,
                    ]}

                    <tr>
                      <td style={{ minWidth: '200px' }}>
                        <span style={{ display: 'flex' }}>
                          {(this.state.visibleUnit ||
                            this.state.visibleStation) && (
                            <LabelBold style={{ ...inlineStyle }}>
                              View Type :
                            </LabelBold>
                          )}
                          {(this.state.visibleStation ||
                            this.state.visibleUnit) && (
                            <Radio.Group
                              style={{ display: 'grid', marginLeft: '10px' }}
                              onChange={e =>
                                this.setState({
                                  choiceUnitStation: e.target.value,
                                  // visibleUnit: e.target.value === 'unit',
                                  // visibleStation: e.target.value === 'station',
                                  EXEVENT: {},
                                })
                              }
                              value={this.state.choiceUnitStation}
                            >
                              {this.state.visibleUnit && (
                                <Radio value="unit">Unit</Radio>
                              )}
                              {this.state.visibleStation && (
                                <Radio value="station">Station</Radio>
                              )}
                            </Radio.Group>
                          )}
                        </span>
                      </td>

                      {this.state.visibleUnit && (
                        <td style={{ minWidth: '210px' }} valign="bottom">
                          <div>
                            <Button
                              type="primary"
                              style={{ width: '100%' }}
                              onClick={_ =>
                                this.setState({ showUnitModal: true })
                              }
                            >
                              Select Unit
                            </Button>
                          </div>
                          <SelectUnit
                            title="Select Units"
                            visible={this.state.showUnitModal}
                            onOk={data =>
                              this.setState({
                                selUnits: data.selUnits.map(d => d.unit),
                                selUtility: data.selUnits.map(d => d.utility),
                                setUnitUtility: data.selUnits,
                                showUnitModal: false,
                                selectionDisplayTab: 'unit',
                              })
                            }
                            onCancel={_ =>
                              this.setState({ showUnitModal: false })
                            }
                            modalClose={_ =>
                              this.setState({ showUnitModal: false })
                            }
                            unitList={
                              (this.props.CLIENT === AEPREG_CLIENT ||
                                this.props.CLIENT === AEPUNREG_CLIENT) &&
                              this.state.reportId === '205'
                                ? this.props.units.filter(f =>
                                    this.state.aepAcaReportUnitIds.includes(
                                      f.unitId
                                    )
                                  )
                                : this.props.units
                            }
                          />
                        </td>
                      )}

                      {this.state.visibleStation && [
                        <td style={{ minWidth: '210px' }} valign="bottom">
                          <Button
                            onClick={_ =>
                              this.setState({ showStationModal: true })
                            }
                            type="primary"
                            style={{ width: '100%' }}
                            // disabled={(this.props.roleType || []).includes('STATION') ? false : true}
                          >
                            Select Station
                            {/* {(this.props.roleType || []).includes('STATION')
                      ? ''
                      : '(Not Permitted)'} */}
                          </Button>
                          <SelectStation
                            visible={this.state.showStationModal}
                            onOk={_ => _}
                            onCancel={_ =>
                              this.setState({ showStationModal: false })
                            }
                            modalClose={_ =>
                              this.setState({ showStationModal: false })
                            }
                            station={this.state.selStations}
                            setStation={station => {
                              const selUtilityStation = station.map(
                                d => d.utility
                              )

                              this.setState({
                                selStations: station,
                                selUtilityStation,
                                selectionDisplayTab: 'station',
                                // region: this.getRegionList() || [],
                                // river: selectedRiverList,
                                // region: [],
                              })
                            }}
                            filterStation={
                              !this.state.visibleRegionriverStationcodeSelection
                                ? _ => true
                                : id => stationByRiverUnit.includes(id)
                            }
                            // userCompany={userCompany}
                            // companyUtilityMap={companyUtilityMap}
                            // userStation={userStation}
                            // userRoleType={userRoleType}
                            // units={units}
                            // actionPermits={actionPermits}
                          />
                        </td>,
                      ]}
                      {this.state.visibleCauseCode && (
                        <td valign="bottom" style={{}}>
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '150px 180px',
                              gap: '5px',
                              alignItems: 'center',
                            }}
                          >
                            <Checkbox
                              checked={this.state.allCauseCode || false}
                              onChange={e => {
                                this.setState({
                                  allCauseCode: e.target.checked,
                                  selectionDisplayTab:
                                    !e.target.checked &&
                                    this.state.visibleCauseCode
                                      ? 'Cause Code'
                                      : this.state.selectionDisplayTab,
                                })
                              }}
                              style={{
                                marginLeft: '20px',
                                // display: 'flex',
                                justifyContent: 'left',
                                alignContent: 'center',
                              }}
                            >
                              All Cause Code
                            </Checkbox>
                            <Button
                              style={{ ...inlineStyle, marginLeft: '20px' }}
                              type="primary"
                              onClick={() => {
                                this.setState({ causeCodeDialogVisible: true })
                              }}
                              disabled={this.state.allCauseCode}
                            >
                              Select Cause Code
                            </Button>
                          </div>
                        </td>
                      )}
                      {/* {this.state.visibleCauseCode && (
                  <td valign="bottom" style={{}}>
                    <Button
                      style={{ ...inlineStyle, marginLeft: '20px' }}
                      type="primary"
                      onClick={() => {
                        this.setState({ causeCodeDialogVisible: true })
                      }}
                      disabled={this.state.allCauseCode}
                    >
                      Select Cause Code
                    </Button>
                  </td>
                )} */}
                    </tr>
                    {(this.state.visibleStation || this.state.visibleUnit) && (
                      <tr>
                        <td colSpan={5} style={{ padding: '0px' }}>
                          <Divider style={{ margin: '3px' }} />
                        </td>
                      </tr>
                    )}
                    <TR>
                      {this.state.visibleMonthYear && (
                        <TD>
                          <label
                            style={{
                              ...inlineStyle,
                              fontWeight: 'bold',
                              display: 'grid',
                            }}
                          >
                            {this.state.visibleStartDateLabel || 'Start :'}
                          </label>

                          <DatePickerControl.MonthPicker
                            format="MMMM-YYYY"
                            value={this.state.startDate}
                            date={this.state.startDate}
                            onChange={date => {
                              const val = getChangeDateSelectionProps(
                                0,
                                date.startOf('month'),
                                this.state.endDate
                              )

                              this.setState(val, _ =>
                                this.props.setSelectedDateRagePicker([
                                  val.startDate,
                                  val.endDate,
                                ])
                              )
                            }}
                            allowClear={false}
                          />
                        </TD>
                      )}
                      {this.state.visibleStartYear && (
                        <TD>
                          <label
                            style={{
                              ...inlineStyle,
                              fontWeight: 'bold',
                              display: 'grid',
                            }}
                          >
                            {this.state.visibleStartYearLabel || 'Start Year :'}
                            {/* {'Start Year :'} */}
                          </label>

                          <InputNumber
                            style={{ width: '100%' }}
                            value={this.state.startDate.format('YYYY')}
                            onChange={year => {
                              const val = getChangeDateSelectionProps(
                                0,
                                moment(year + '-01-01'),
                                this.state.endDate
                              )
                              this.setState(val, _ =>
                                this.props.setSelectedDateRagePicker([
                                  val.startDate,
                                  val.endDate,
                                ])
                              )
                            }}
                          />
                        </TD>
                      )}
                      {this.state.visibleEndYear && (
                        <TD>
                          <label
                            style={{
                              ...inlineStyle,
                              fontWeight: 'bold',
                              display: 'grid',
                            }}
                          >
                            End Year :
                          </label>
                          <InputNumber
                            style={{ width: '100%' }}
                            value={this.state.endDate.format('YYYY')}
                            onChange={year => {
                              const val = getChangeDateSelectionProps(
                                0,
                                this.state.startDate,
                                moment(year + '-12-31')
                              )
                              this.setState(val, _ =>
                                this.props.setSelectedDateRagePicker([
                                  val.startDate,
                                  val.endDate,
                                ])
                              )
                            }}
                          />
                        </TD>
                      )}

                      {this.state.visibleMonthYearEnd && (
                        <TD>
                          <label
                            style={{
                              ...inlineStyle,
                              fontWeight: 'bold',
                              display: 'grid',
                            }}
                          >
                            End :
                          </label>
                          <DatePickerControl.MonthPicker
                            allowClear={false}
                            format="MMMM-YYYY"
                            value={this.state.endDate}
                            onChange={date => {
                              const val = getChangeDateSelectionProps(
                                0,
                                this.state.startDate,
                                date.endOf('month')
                              )
                              this.setState(val, _ =>
                                this.props.setSelectedDateRagePicker([
                                  val.startDate,
                                  val.endDate,
                                ])
                              )
                            }}
                            // onChange={date =>
                            //   this.setState({
                            //     monthyearendmoment: date,
                            //     monthyearend: {
                            //       month: date.format('MM'),
                            //       year: date.format('YYYY'),
                            //     },
                            //   })
                            // }
                          />
                        </TD>
                      )}

                      {this.state.visibleStartDate && (
                        <TD style={{ maxWidth: '200px' }}>
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumn: '3px 1px',
                            }}
                          >
                            <LabelBold
                              style={{
                                ...inlineStyle,
                                marginRight: '10px',
                                gridColumnEnd: 'span 2',
                              }}
                            >
                              {`${this.state.visibleStartDateLabel} : `}
                            </LabelBold>
                            <DatePicker
                              allowClear={false}
                              style={{ ...inlineStyle, width: '150px' }}
                              date={this.state.startDate || moment()}
                              value={this.state.startDate}
                              // dateProps={dateProps}
                              setDate={date => {
                                const val = getChangeDateSelectionProps(
                                  0,
                                  date,
                                  this.state.endDate
                                )
                                this.setState(val, _ =>
                                  this.props.setSelectedDateRagePicker([
                                    val.startDate,
                                    val.endDate,
                                  ])
                                )
                              }}
                              // onChange={date1 => {
                              //   getHeInDay(this.props.targetInfo)(date1).fork(
                              //     _ => _,
                              //     d => this.setState({ startDate: date1, startHourList: d })
                              //   )
                              // }}
                            />
                            {this.state.visibleStartHour && (
                              <Select
                                onChange={value =>
                                  this.setState({
                                    selectedStartHour: value,
                                    dateSelectionType: 0,
                                  })
                                }
                                style={{ ...inlineStyle, width: '60px' }}
                                value={this.state.selectedStartHour}
                              >
                                {convertHourToObject(0)(
                                  this.state.startHourList
                                ).map(r => (
                                  <Select.Option value={r.value}>
                                    {r.text}
                                  </Select.Option>
                                ))}
                              </Select>
                            )}
                          </div>
                        </TD>
                      )}

                      {this.state.visibleEndDate && (
                        <TD style={{ maxWidth: '200px' }}>
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumn: '3px 1px',
                            }}
                          >
                            <LabelBold
                              style={{
                                ...inlineStyle,
                                marginRight: '10px',
                                gridColumnEnd: 'span 2',
                              }}
                            >
                              {`${this.state.visibleEndDateLabel} : `} &nbsp;
                            </LabelBold>
                            <DatePicker
                              allowClear={false}
                              style={{ ...inlineStyle }}
                              size="small"
                              date={this.state.endDate}
                              // setDate={this.props.setDate}
                              // dateProps={dateProps}
                              setDate={date => {
                                const val = getChangeDateSelectionProps(
                                  0,
                                  this.state.startDate,
                                  date
                                )
                                this.setState(val, _ =>
                                  this.props.setSelectedDateRagePicker([
                                    val.startDate,
                                    val.endDate,
                                  ])
                                )
                              }}
                            />
                            {this.state.visibleEndHour && (
                              <Select
                                onChange={value =>
                                  this.setState({
                                    selectedEndHour: value,
                                    dateSelectionType: 0,
                                  })
                                }
                                style={{ ...inlineStyle, width: '60px' }}
                                value={this.state.selectedEndHour}
                              >
                                {convertHourToObject(1)(
                                  this.props.endDateHourList
                                ).map(r => (
                                  <Select.Option value={r.value}>
                                    {r.text}
                                  </Select.Option>
                                ))}
                              </Select>
                            )}
                          </div>
                        </TD>
                      )}
                      {this.state.visibleCustomDateSelection && (
                        <td colSpan="2" style={{ maxWidth: '200px' }}>
                          <div style={{ dispaly: 'grid' }}>
                            <LabelBold
                              style={{
                                ...inlineStyle,
                                marginRight: '10px',
                                gridColumnEnd: 'span 1',
                              }}
                            >
                              Custom Date Selection :
                            </LabelBold>
                            <div style={{ display: 'grid' }}>
                              <Select
                                style={{ ...inlineStyle }}
                                defaultValue={0}
                                value={this.state.dateSelectionType}
                                onChange={this.changeDateSelectionType}
                              >
                                <Select.Option value={0}>
                                  Custom Select
                                </Select.Option>
                                <Select.Option value={1}>
                                  Current Month
                                </Select.Option>
                                <Select.Option value={2}>
                                  Previous Month
                                </Select.Option>
                                <Select.Option value={3}>
                                  Current Year
                                </Select.Option>
                                <Select.Option value={4}>
                                  Year To Date
                                </Select.Option>
                                <Select.Option value={5}>
                                  Month To Date
                                </Select.Option>
                                <Select.Option value={6}>
                                  Previous Year
                                </Select.Option>
                                <Select.Option value={7}>
                                  Year To Month
                                </Select.Option>
                                <Select.Option value={8}>
                                  Year To Last Month
                                </Select.Option>
                                <Select.Option value={9}>
                                  Trailing Twelve Month
                                </Select.Option>
                                <Select.Option value={10}>
                                  Complete Year
                                </Select.Option>
                                <Select.Option value={11}>
                                  First Quarter
                                </Select.Option>
                                <Select.Option value={12}>
                                  Second Quarter
                                </Select.Option>
                                <Select.Option value={13}>
                                  Third Quarter
                                </Select.Option>
                                <Select.Option value={14}>
                                  Fourth Quarter
                                </Select.Option>
                              </Select>
                            </div>
                          </div>
                        </td>
                      )}
                    </TR>
                    <tr>
                      <td colSpan={5} style={{ padding: '0px' }}>
                        <Divider style={{ margin: '3px' }} />
                      </td>
                    </tr>
                    <TR>
                      {this.state.visiblePjmNerc && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({ typeBy: e.target.value })
                            }
                            value={this.state.typeBy}
                            disabled={!this.state.visiblePjmNerc}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Method :{' '}
                            </LabelBold>
                            <Radio value="1">PJM</Radio>
                            <Radio value="2">NERC</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleEffectieveDate && (
                        <TD>
                          <div>
                            <div> Eff. Date :</div>
                            <DatePicker
                              allowClear={false}
                              style={{ ...inlineStyle }}
                              size="small"
                              date={this.state.effeDate}
                              setDate={date =>
                                this.setState({
                                  effeDate: date,
                                  effeDateStr: date.format('MM/DD/YYYY'),
                                })
                              }
                            />
                          </div>
                        </TD>
                      )}
                      {this.state.visibleOMC && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({ omc: e.target.value })
                            }
                            value={this.state.omc}
                            disabled={!this.state.visibleOMC}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              OMC :{' '}
                            </LabelBold>
                            <Radio value="1">Include</Radio>
                            <Radio value="2">Exclude</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleExcludeOmc && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({ omc: e.target.value })
                            }
                            value={this.state.omc}
                            disabled={!this.state.visibleExcludeOmc}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              OMC :{' '}
                            </LabelBold>
                            <Radio value="1">Exc None</Radio>
                            <Radio value="2">Exc NERC OMC</Radio>
                            <Radio value="3">Exc BREG OMC</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleFormat && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({
                                horizontalvartical: e.target.value,
                              })
                            }
                            value={this.state.horizontalvartical}
                            disabled={!this.state.visibleFormat}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Format :{' '}
                            </LabelBold>
                            <Radio value="Vartical">Vertical</Radio>
                            <Radio value="Horizontal">Horizontal</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleRollupDetail && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({ rollupdetail: e.target.value })
                            }
                            value={this.state.rollupdetail}
                            disabled={!this.state.visibleRollupDetail}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Report Type :
                            </LabelBold>
                            <Radio value="2">Rollup</Radio>
                            <Radio value="1">Detail</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleMonthlyCauseCodeFlag && (
                        <TD>
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '1fr',
                            }}
                          >
                            <Checkbox
                              disabled={!this.state.visibleMonthlyCauseCodeFlag}
                              checked={
                                this.state.monthlycausecodeMonthly === 'YES'
                              }
                              onChange={e =>
                                this.setState({
                                  monthlycausecodeMonthly: e.target.checked
                                    ? 'YES'
                                    : 'NO',
                                })
                              }
                            >
                              Monthly
                            </Checkbox>
                            <Checkbox
                              style={{ margin: '0px' }}
                              checked={
                                this.state.monthlycausecodeCausecode === 'YES'
                              }
                              onChange={e =>
                                this.setState({
                                  monthlycausecodeCausecode: e.target.checked
                                    ? 'YES'
                                    : 'NO',
                                })
                              }
                            >
                              Cause Code
                            </Checkbox>
                          </div>
                        </TD>
                      )}

                      {this.state.visibleWinterSummer && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({ rollupdetail: e.target.value })
                            }
                            value={this.state.rollupdetail}
                            disabled={!this.state.visibleWinterSummer}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Report Type :
                            </LabelBold>
                            {this.state.visibleSeasonBoth && (
                              <Radio value="3">Both</Radio>
                            )}
                            <Radio value="1">Winter</Radio>
                            <Radio value="2">Summer</Radio>
                          </Radio.Group>
                        </TD>
                      )}

                      {this.state.visibleFinalsummary && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({ rollupdetail: e.target.value })
                            }
                            value={this.state.rollupdetail}
                            disabled={!this.state.visibleFinalsummary}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Report Type :
                            </LabelBold>
                            <Radio value="1">Exc. Final Summary</Radio>
                            <Radio value="2">Inc. Final Summary</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleGoals && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({ rollupdetail: e.target.value })
                            }
                            value={this.state.rollupdetail}
                            disabled={!this.state.visibleRollupDetail}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Report Type :
                            </LabelBold>
                            <Radio value="1">Statistics Goals</Radio>
                            <Radio value="2">Metrics Goals</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visible2550all && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({ rollupdetail: e.target.value })
                            }
                            value={this.state.rollupdetail}
                            // disabled={!this.state.visibleRollupDetail}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Report Type :
                            </LabelBold>
                            {this.props.visible2550showAll && (
                              <Radio value="3">All</Radio>
                            )}
                            <Radio value="2">50</Radio>
                            <Radio value="1">25</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleEventHourDuration && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({ rollupdetail: e.target.value })
                            }
                            value={this.state.rollupdetail}
                            // disabled={!this.state.visibleRollupDetail}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Event Duration :
                            </LabelBold>
                            <Radio value="1">
                              Limit Hours Within Report Date Range
                            </Radio>
                            <Radio value="2">
                              Show Hours for the Entire Event
                            </Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleGroupByMonthOrUnit && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({
                                groupbymonthunit: e.target.value,
                              })
                            }
                            value={this.state.groupbymonthunit}
                            disabled={!this.state.visibleGroupByMonthOrUnit}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Group By :{' '}
                            </LabelBold>
                            <Radio value="month">Month</Radio>
                            <Radio value="unit">Unit</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleEventDuration && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({
                                groupbymonthunit: e.target.value,
                              })
                            }
                            value={this.state.groupbymonthunit}
                            disabled={!this.state.visibleEventDuration}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Group By :{' '}
                            </LabelBold>
                            <Radio value="month">Events Duration</Radio>
                            <Radio value="unit">Period Duration</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleYTD && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({
                                groupbymonthunit: e.target.value,
                              })
                            }
                            value={this.state.groupbymonthunit}
                            disabled={!this.state.visibleYTD}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Group By :{' '}
                            </LabelBold>
                            <Radio value="month">Exclude YTD</Radio>
                            <Radio value="unit">Include YTD</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleByCategoryCauseCode && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({
                                groupbymonthunit: e.target.value,
                              })
                            }
                            value={this.state.groupbymonthunit}
                            disabled={!this.state.visibleByCategoryCauseCode}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Group By :{' '}
                            </LabelBold>
                            <Radio value="month">Category</Radio>
                            <Radio value="unit">Cause Code</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleByRegionFuel && (
                        <TD>
                          <Radio.Group
                            style={{ display: 'grid' }}
                            onChange={e =>
                              this.setState({
                                groupbymonthunit: e.target.value,
                              })
                            }
                            value={this.state.groupbymonthunit}
                            disabled={!this.state.visibleByRegionFuel}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Group By :{' '}
                            </LabelBold>
                            <Radio value="month">Region</Radio>
                            <Radio value="unit">Fuel</Radio>
                          </Radio.Group>
                        </TD>
                      )}
                      {this.state.visibleGorpIRMB &&
                        this.state.avaliableGorpIRMB && (
                          <TD>
                            <Radio.Group
                              style={{ display: 'grid' }}
                              onChange={e =>
                                this.setState({
                                  groupbymonthunit: e.target.value,
                                })
                              }
                              value={this.state.groupbymonthunit}
                              disabled={!this.state.visibleGorpIRMB}
                            >
                              <LabelBold style={{ ...inlineStyle }}>
                                Group By :{' '}
                              </LabelBold>
                              <Radio value="month">Include IR/MB</Radio>
                              <Radio value="unit">Exclude IR/MB</Radio>
                            </Radio.Group>
                          </TD>
                        )}
                      {this.state.visibleEafCheckbox && (
                        <TD>
                          <Checkbox
                            checked={this.state.eafOnly === 'Y'}
                            onChange={e =>
                              this.setState({
                                eafOnly: e.target.checked ? 'Y' : 'N',
                              })
                            }
                          >
                            EAF only
                          </Checkbox>
                        </TD>
                      )}
                      {this.state.visibleMW2Exclude && (
                        <TD>
                          <Checkbox
                            checked={this.state.eafOnly === 'Y'}
                            onChange={e =>
                              this.setState({
                                eafOnly: e.target.checked ? 'Y' : 'N',
                              })
                            }
                          >
                            {`< 2 MW Exclude`}
                          </Checkbox>
                        </TD>
                      )}
                      {this.state.visibleErrorCodeCheckbox && (
                        <Checkbox
                          checked={this.state.errorCodeSort}
                          onChange={e =>
                            this.setState({ errorCodeSort: e.target.checked })
                          }
                        >
                          Sort by Error Code
                        </Checkbox>
                      )}
                    </TR>
                    <tr>
                      <td colSpan={5} style={{ padding: '0px' }}>
                        <Divider style={{ margin: '3px' }} />
                      </td>
                    </tr>
                    <TR>
                      {this.state.visibleDataSet && (
                        <td colSpan={2}>
                          <LabelBold style={{ ...inlineStyle }}>
                            Dataset :{' '}
                          </LabelBold>
                          <Select
                            style={{ width: '100%', ...inlineStyle }}
                            value={this.state.dataset}
                            onChange={value =>
                              this.setState({ dataset: value })
                            }
                            disabled={!this.state.visibleDataSet}
                          >
                            {this.state.auditReportDataset?.map(d => (
                              <Select.Option value={d}>{d}</Select.Option>
                            ))}
                          </Select>
                        </td>
                      )}

                      {this.state.visibleEventTypes && (
                        <td colSpan="4" style={{}}>
                          <div
                            style={{
                              maxWidth: 'fit-content',
                              minWidth: '100%',
                            }}
                          >
                            <LabelBold style={{ ...inlineStyle }}>
                              Event Type :{' '}
                            </LabelBold>
                            <Select
                              style={{ ...inlineStyle, width: '100%' }}
                              value={this.state.eventType}
                              onChange={value => {
                                if (value.includes('All')) {
                                  const ev = this.props.eventTypes.map(
                                    d => d.eventType
                                  )
                                  const ex =
                                    this.props.CLIENT === BROOKFIELD_CLIENT ||
                                    this.props.CLIENT === TVA_CLIENT ||
                                    this.props.CLIENT === NYISO_CLIENT
                                      ? ['CO', 'PU']
                                      : []
                                  this.setState({
                                    eventType: [...ev, ...ex],
                                  })
                                } else this.setState({ eventType: value })
                              }}
                              mode="multiple"
                              disabled={!this.state.visibleEventTypes}
                            >
                              <Select.Option value="All">All</Select.Option>
                              {this.props.eventTypes.map(d => (
                                <Select.Option value={d.eventType}>
                                  {d.eventType}
                                </Select.Option>
                              ))}
                              {(this.props.CLIENT === BROOKFIELD_CLIENT ||
                                this.props.CLIENT === TVA_CLIENT ||
                                this.props.CLIENT === NYISO_CLIENT) && [
                                <Select.Option value="CO">CO</Select.Option>,
                                <Select.Option value="PU">PU</Select.Option>,
                              ]}
                            </Select>
                          </div>
                        </td>
                      )}
                    </TR>

                    {/* {this.state.visibleCauseCode && !this.state.allCauseCode && (
                      <TR>
                        <td colSpan={5}>
                          <LabelBold style={{ ...inlineStyle }}>
                            Selected Cause Code :{' '}
                          </LabelBold>
                          <div
                            style={{
                              maxHeight: height / 4,
                              // maxWidth: '800px',
                              overflow: 'auto',
                              padding: '2px',
                              border: '1px solid #e8e8e8',
                              // minHeight: '50px',
                              display: 'flex',
                              // gridTemplateColumns: '400px 400px',
                              flexFlow: 'row',
                              flexWrap: 'wrap',
                            }}
                          >
                            {sortCauseCodeData.map(id => (
                              <div style={{ margin: '1px' }}>
                                <Tag style={{}}>
                                  {id}-{this.props.causeCodeMap[id]}
                                </Tag>
                              </div>
                            ))}
                          </div>
                        </td>
                      </TR>
                    )} */}
                    {this.state.visible10StartEndMonth && (
                      <tr>
                        <td colSpan={3}>
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '1fr 1fr 1fr 1fr',
                              gap: '5px',
                            }}
                          >
                            <div>Start : </div>
                            <div>End : </div>
                            <div>Start : </div>
                            <div>End : </div>
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 's1')}
                              value={this.getDateMap('s1')}
                              placeholder="Start Date 1"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 'e1')}
                              value={this.getDateMap('e1')}
                              placeholder="End Date 1"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 's2')}
                              value={this.getDateMap('s2')}
                              placeholder="Start Date 2"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 'e2')}
                              value={this.getDateMap('e2')}
                              placeholder="End Date 2"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 's3')}
                              value={this.getDateMap('s3')}
                              placeholder="Start Date 3"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 'e3')}
                              value={this.getDateMap('e3')}
                              placeholder="End Date 3"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 's4')}
                              value={this.getDateMap('s4')}
                              placeholder="Start Date 4"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 'e4')}
                              value={this.getDateMap('e4')}
                              placeholder="End Date 4"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 's5')}
                              value={this.getDateMap('s5')}
                              placeholder="Start Date 5"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 'e5')}
                              value={this.getDateMap('e5')}
                              placeholder="End Date 5"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 's6')}
                              value={this.getDateMap('s6')}
                              placeholder="Start Date 6"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 'e6')}
                              value={this.getDateMap('e6')}
                              placeholder="End Date 6"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 's7')}
                              value={this.getDateMap('s7')}
                              placeholder="Start Date 7"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 'e7')}
                              value={this.getDateMap('e7')}
                              placeholder="End Date 7"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 's8')}
                              value={this.getDateMap('s8')}
                              placeholder="Start Date 8"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 'e8')}
                              value={this.getDateMap('e8')}
                              placeholder="End Date 8"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 's9')}
                              value={this.getDateMap('s9')}
                              placeholder="Start Date 9"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 'e9')}
                              value={this.getDateMap('e9')}
                              placeholder="End Date 9"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 's10')}
                              value={this.getDateMap('s10')}
                              placeholder="Start Date 10"
                            />
                            <DatePickerControl.MonthPicker
                              format="MMMM-YYYY"
                              style={{ width: '100%' }}
                              onChange={date => this.setDateMap(date, 'e10')}
                              value={this.getDateMap('e10')}
                              placeholder="End Date 10"
                            />
                          </div>
                        </td>
                      </tr>
                    )}
                    {(this.state.visible6StartEndDate ||
                      this.state.visible6ExceludeEvent) && (
                      <tr>
                        {this.state.visible6StartEndDate && (
                          <td colSpan={2}>
                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '80px 250px',
                                gap: '5px',
                              }}
                            >
                              <div />
                              <div>
                                <b>Select Range : </b>
                              </div>
                              <div style={{ gridColumnEnd: 'span 1' }} />
                              <div>Start Date - End Date </div>
                              <div
                                style={{
                                  display: 'grid',
                                  justifyContent: 'right',
                                  alignContent: 'center',
                                }}
                              >
                                Range 1 :
                              </div>
                              <DatePickerControl.RangePicker
                                format="MM/DD/YYYY"
                                style={{ width: '100%' }}
                                onChange={dates => {
                                  if (dates) {
                                    this.setDateMap(dates[0], 's1')
                                    this.setDateMap(dates[1], 'e1')
                                  } else {
                                    this.setDateMap(null, 's1')
                                    this.setDateMap(null, 'e1')
                                  }
                                }}
                                value={[
                                  this.getDateMap('s1'),
                                  this.getDateMap('e1'),
                                ]}
                                placeholder="Start Date 1"
                              />
                              <div
                                style={{
                                  display: 'grid',
                                  justifyContent: 'right',
                                  alignContent: 'center',
                                }}
                              >
                                Range 2 :
                              </div>
                              <DatePickerControl.RangePicker
                                format="MM/DD/YYYY"
                                style={{ width: '100%' }}
                                onChange={dates => {
                                  if (dates) {
                                    this.setDateMap(dates[0], 's2')
                                    this.setDateMap(dates[1], 'e2')
                                  } else {
                                    this.setDateMap(null, 's2')
                                    this.setDateMap(null, 'e2')
                                  }
                                }}
                                value={[
                                  this.getDateMap('s2'),
                                  this.getDateMap('e2'),
                                ]}
                                placeholder="Start Date 2"
                              />
                              <div
                                style={{
                                  display: 'grid',
                                  justifyContent: 'right',
                                  alignContent: 'center',
                                }}
                              >
                                Range 3 :
                              </div>
                              <DatePickerControl.RangePicker
                                format="MM/DD/YYYY"
                                style={{ width: '100%' }}
                                onChange={dates => {
                                  if (dates) {
                                    this.setDateMap(dates[0], 's3')
                                    this.setDateMap(dates[1], 'e3')
                                  } else {
                                    this.setDateMap(null, 's3')
                                    this.setDateMap(null, 'e3')
                                  }
                                }}
                                value={[
                                  this.getDateMap('s3'),
                                  this.getDateMap('e3'),
                                ]}
                                placeholder="Start Date 3"
                              />
                              <div
                                style={{
                                  display: 'grid',
                                  justifyContent: 'right',
                                  alignContent: 'center',
                                }}
                              >
                                Range 4 :
                              </div>
                              <DatePickerControl.RangePicker
                                format="MM/DD/YYYY"
                                style={{ width: '100%' }}
                                onChange={dates => {
                                  if (dates) {
                                    this.setDateMap(dates[0], 's4')
                                    this.setDateMap(dates[1], 'e4')
                                  } else {
                                    this.setDateMap(null, 's4')
                                    this.setDateMap(null, 'e4')
                                  }
                                }}
                                value={[
                                  this.getDateMap('s4'),
                                  this.getDateMap('e4'),
                                ]}
                                placeholder="Start Date 4"
                              />
                              <div
                                style={{
                                  display: 'grid',
                                  justifyContent: 'right',
                                  alignContent: 'center',
                                }}
                              >
                                Range 5 :
                              </div>
                              <DatePickerControl.RangePicker
                                format="MM/DD/YYYY"
                                style={{ width: '100%' }}
                                onChange={dates => {
                                  if (dates) {
                                    this.setDateMap(dates[0], 's5')
                                    this.setDateMap(dates[1], 'e5')
                                  } else {
                                    this.setDateMap(null, 's5')
                                    this.setDateMap(null, 'e5')
                                  }
                                }}
                                value={[
                                  this.getDateMap('s5'),
                                  this.getDateMap('e5'),
                                ]}
                                placeholder="Start Date 5"
                              />
                              <div
                                style={{
                                  display: 'grid',
                                  justifyContent: 'right',
                                  alignContent: 'center',
                                }}
                              >
                                Range 6 :
                              </div>
                              <DatePickerControl.RangePicker
                                format="MM/DD/YYYY"
                                style={{ width: '100%' }}
                                onChange={dates => {
                                  if (dates) {
                                    this.setDateMap(dates[0], 's6')
                                    this.setDateMap(dates[1], 'e6')
                                  } else {
                                    this.setDateMap(null, 's6')
                                    this.setDateMap(null, 'e6')
                                  }
                                }}
                                value={[
                                  this.getDateMap('s6'),
                                  this.getDateMap('e6'),
                                ]}
                                placeholder="Start Date 6"
                              />
                            </div>
                          </td>
                        )}
                        {(this.state.visible6ExceludeEvent ||
                          this.state.visible10ExceludeEvent) && (
                          <td colSpan={3}>
                            <div
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '200px 100px 100px',
                                gap: 5,
                              }}
                            >
                              <div style={{ gridColumnEnd: 'span 3' }}>
                                <b> Events to be Excluded :</b>
                              </div>

                              <div>Unit Names :</div>
                              <div>Year :</div>
                              <div>Event Number :</div>
                              {R.range(1, 7).map(i => (
                                <EventExcludes
                                  EXEVENT={this.state.EXEVENT}
                                  EX={'EX' + i}
                                  setData={data => this.setState(data)}
                                  unitList={this.state.setUnitUtility}
                                  isStation={
                                    this.state.choiceUnitStation === 'station'
                                  }
                                  selStations={this.state.selStations}
                                  selUtilityStation={
                                    this.state.selUtilityStation
                                  }
                                  allUnits={this.props.units}
                                />
                              ))}

                              {this.state.visible10ExceludeEvent && (
                                <React.Fragment>
                                  {R.range(7, 11).map(i => (
                                    <EventExcludes
                                      EXEVENT={this.state.EXEVENT}
                                      EX={'EX' + i}
                                      setData={data => this.setState(data)}
                                      unitList={this.state.setUnitUtility}
                                      isStation={
                                        this.state.choiceUnitStation ===
                                        'station'
                                      }
                                      selStations={this.state.selStations}
                                      selUtilityStation={
                                        this.state.selUtilityStation
                                      }
                                      allUnits={this.props.units}
                                    />
                                  ))}
                                </React.Fragment>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    )}

                    <tr>
                      <td colSpan={5} style={{ padding: '0px' }}>
                        <Divider style={{ margin: '3px' }} />
                      </td>
                    </tr>
                    <TR>
                      <td>
                        {this.state.visibleMAGroup && (
                          <div style={{ textAlign: 'end' }}>Group :</div>
                        )}
                      </td>

                      {this.state.visibleMAGroup && (
                        <td colSpan={5}>
                          <Select
                            style={{
                              ...inlineStyle,
                              width: '100%',
                              gridColumnEnd: 'span 4',
                            }}
                            value={this.state.maGroupSelection}
                            onChange={value => {
                              this.setState({ maGroupSelection: value })
                            }}
                            mode="multiple"
                            disabled={!this.state.visibleMAGroup}
                          >
                            {this.state.maGroupList.map(d => (
                              <Select.Option value={d}>{d}</Select.Option>
                            ))}
                          </Select>
                        </td>
                      )}
                    </TR>
                    {false && this.state.visibleWindUtilitySelection && (
                      <td colSpan={4} style={{ height: '100px' }}>
                        <Select
                          placeholder="Select Wind Utility"
                          style={{
                            width: '100%',
                            ...inlineStyle,
                            display: 'grid',
                            height: '100%',
                            maxWidth: 'fitContent',
                          }}
                          value={this.state.windUtilitySelection}
                          onChange={value =>
                            this.setState({ windUtilitySelection: value })
                          }
                          disabled={!this.state.visibleWindUtilitySelection}
                          mode="multiple"
                        >
                          {Object.keys(this.windUtilityIdNameMap).map(k => (
                            <Select.Option value={k}>
                              {this.windUtilityIdNameMap[k]}
                            </Select.Option>
                          ))}
                        </Select>
                      </td>
                    )}
                    {this.state.visibleWindSubgroupSelection && (
                      <TR>
                        <td colSpan={4} style={{ height: '150px' }}>
                          <div
                            style={{
                              width: '100%',
                              ...inlineStyle,
                              display: 'grid',
                              height: '100%',
                              maxWidth: 'fit-content',
                              overflow: 'auto',
                              gridTemplateColumns: '1fr',
                              minWidth: '100%',
                              overflowWrap: 'anywhere',
                            }}
                          >
                            <Select
                              placeholder="Select Wind Subgroups"
                              style={{
                                //   width: '100%',
                                ...inlineStyle,
                                display: 'grid',
                                height: '100%',
                                //  maxWidth: 'fit-content',
                              }}
                              value={this.state.windSelection}
                              onChange={value => {
                                const selUtility = value.map(w =>
                                  w.substr(0, w.indexOf('-'))
                                )
                                const selUnits = value.map(w =>
                                  w.substr(w.indexOf('-') + 1)
                                )
                                this.setState({
                                  windSelection: value,
                                  selUnits,
                                  selUtility,
                                })
                              }}
                              disabled={
                                !this.state.visibleWindSubgroupSelection
                              }
                              mode="multiple"
                            >
                              {Object.keys(this.windUtilitySubgroup).map(ut =>
                                R.flatten(
                                  this.windUtilitySubgroup[ut].map(sg => (
                                    <Select.Option value={ut + '-' + sg}>
                                      {this.windUtilityIdNameMap[ut] +
                                        '-' +
                                        this.windSubgroupIdNameMap[sg]}
                                    </Select.Option>
                                  ))
                                )
                              )}
                            </Select>
                          </div>
                        </td>
                      </TR>
                    )}
                  </table>
                </div>
                {/* <List pagination={true} style={{ minWidth: '150px' }}> */}
                <Divider
                  type="vertical"
                  style={{ height: '100%', margin: '2px' }}
                />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gridTemplateRows: 'min-content auto',
                  }}
                >
                  <Radio.Group
                    defaultValue="unit"
                    value={this.state.selectionDisplayTab || 'unit'}
                    onChange={e =>
                      this.setState({ selectionDisplayTab: e.target.value })
                    }
                    style={{ margin: '10px', borderBottom: '0px solid gray' }}
                  >
                    {this.state.visibleUnit && (
                      <Radio.Button value="unit">Unit</Radio.Button>
                    )}
                    {this.state.visibleStation && (
                      <Radio.Button value="station">Station</Radio.Button>
                    )}
                    {!this.state.allCauseCode &&
                      this.state.visibleCauseCode && (
                        <Radio.Button value="Cause Code">
                          Selected Cause Code
                        </Radio.Button>
                      )}
                  </Radio.Group>
                  {(this.state.visibleUnit || this.state.visibleStation) &&
                    this.state.selectionDisplayTab === 'unit' && (
                      <div
                        style={{
                          disabled: 'flex ',
                          gridTemplateColumns: '1fr',
                          overflow: 'auto',
                          maxHeight: '400px',
                          minHeight: '400px',
                          // border: '1px dashed blue',
                          padding: '1px',
                        }}
                      >
                        {R.sort(
                          (a, b) =>
                            a === undefined || b === undefined
                              ? 0
                              : a.toLowerCase() < b.toLowerCase()
                              ? 0
                              : 1,
                          (this.state.setUnitUtility || []).map(u => u.unitName)
                        ).map(u => (
                          <Tag>{u}</Tag>
                        ))}
                      </div>
                    )}
                  {(this.state.visibleUnit || this.state.visibleStation) &&
                    this.state.selectionDisplayTab === 'station' && (
                      <div
                        style={{
                          disabled: 'flex ',
                          gridTemplateColumns: '1fr',
                          overflow: 'auto',
                          maxHeight: '400px',
                          minHeight: '400px',
                        }}
                      >
                        {(this.state.selStations || []).map(u => (
                          <Tag>{u.unitName}</Tag>
                        ))}
                      </div>
                    )}

                  {this.state.selectionDisplayTab === 'Cause Code' &&
                    !this.state.allCauseCode && (
                      <div
                        style={{
                          disabled: 'flex ',
                          gridTemplateColumns: '1fr',
                          overflow: 'auto',
                          maxHeight: height - 100,
                          minHeight: '400px',
                          // border: '1px dashed blue',
                          padding: '1px',
                        }}
                      >
                        {sortCauseCodeData.map(id => (
                          <div style={{ margin: '1px' }}>
                            <Tag style={{}}>
                              {id}-{this.props.causeCodeMap[id]}
                            </Tag>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
                {/*  <Tabs style={{ border: '0px solid black' }}>
              {this.state.visibleUnit && (
                <Tabs.TabPane key="unit" tab="Selected Units">
                  <div
                    style={{
                      disabled: 'flex ',
                      gridTemplateColumns: '1fr',
                      overflow: 'auto',
                      maxHeight: '400px',
                      minHeight: '400px',
                      // border: '1px dashed blue',
                      padding: '1px',
                    }}
                  >
                    {R.sort(
                      (a, b) =>
                        a === undefined || b === undefined
                          ? 0
                          : a.toLowerCase() < b.toLowerCase()
                          ? 0
                          : 1,
                      (this.state.setUnitUtility || []).map(u => u.unitName)
                    ).map(u => (
                      <Tag>{u}</Tag>
                    ))}
                  </div>
                </Tabs.TabPane>
              )}
              {this.state.visibleStation && (
                <Tabs.TabPane key="station" tab="Selected Stations">
                  <div
                    style={{
                      disabled: 'flex ',
                      gridTemplateColumns: '1fr',
                      overflow: 'auto',
                      maxHeight: '400px',
                      minHeight: '400px',
                    }}
                  >
                    {(this.state.selStations || []).map(u => (
                      <Tag>{u.unitName}</Tag>
                    ))}
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs> */}
              </div>
            </Content>
          )}
        </FullHeightSizer>
      </>
    )
  }

  changeDateSelectionType(dateSelectionType) {
    this.setState({ dateSelectionType })
    const val = getChangeDateSelectionProps(
      dateSelectionType,
      this.state.startDate,
      this.state.endDate
    )
    this.setState(val, _ =>
      this.props.setSelectedDateRagePicker([val.startDate, val.endDate])
    )
  }

  constructor(props, context) {
    super(props, context)

    const mom = moment()
      .subtract(1, 'month')
      .startOf('month')
    const month = mom.format('MM')
    const year = parseInt(mom.format('YYYY'))
    // let mmt = new moment().set('DD', '01')
    const { authGodMode } = props.envConfig
    const actionPermits = props.actionPermits

    const hasCard95AccessPermission = hasAccesPermits({
      authGodMode,
      actionPermits,
      eventActions: [
        ScreenPermissions.CARD95_HISTORY_VIEWER,
        ScreenPermissions.CARD95_VIEWER,
        ScreenPermissions.CARD95_ADMIN,
      ],
      matchAny: true,
    })

    const hasCard97AccessPermission = hasAccesPermits({
      authGodMode,
      actionPermits,
      eventActions: [
        ScreenPermissions.CARD97_HISTORY_VIEWER,
        ScreenPermissions.CARD97_VIEWER,
        ScreenPermissions.CARD97_ADMIN,
      ],
      matchAny: true,
    })

    const hasCard99AccessPermission = hasAccesPermits({
      authGodMode,
      actionPermits,
      eventActions: [
        ScreenPermissions.CARD99_HISTORY_VIEWER,
        ScreenPermissions.CARD99_VIEWER,
        ScreenPermissions.CARD99_ADMIN,
      ],
      matchAny: true,
    })

    const cardPermissions = [
      { name: 'Card95 Performance', permission: hasCard95AccessPermission },
      { name: 'Card97 Events', permission: hasCard97AccessPermission },
      { name: 'Card99 Fuel', permission: hasCard99AccessPermission },
    ]

    const auditReportDataset = cardPermissions
      .filter(item => item.permission)
      .map(item => item.name)

    const defaultDataset =
      auditReportDataset.length > 0 ? auditReportDataset[0] : ''

    this.REPORT_EXCEL_PERMISSION = hasAccesPermits({
      authGodMode,
      actionPermits: props.actionPermits,
      eventActions: [ScreenPermissions.REPORT_EXCEL],
      matchAny: true,
    })

    this.REPORT_JASPER_PERMISSION = hasAccesPermits({
      authGodMode,
      actionPermits: props.actionPermits,
      eventActions: [ScreenPermissions.REPORT_JASPER_ACCESS],
      matchAny: true,
    })

    this.state = {
      loading: false,
      ...visibleCompoValues,
      startDate: moment()
        .subtract(1, 'month')
        .startOf('month'),
      endDate: moment()
        .subtract(1, 'month')
        .endOf('month'),
      typeBy: '1',
      startHourList: [],
      selectedStartHour: 0,
      selectedEndHour: 24,
      selUtility: [],
      selUtilityStation: [],
      selUnits: [],
      monthyear: { month, year },
      monthyearend: { month, year },
      reportNames: [],
      selectedReportName: '',
      dataset: defaultDataset,
      auditReportDataset: auditReportDataset,
      omc: '1',
      rollupdetail: '1',
      groupbymonthunit: 'unit',
      horizontalvartical: 'Horizontal',
      causeCodeDialogVisible: false,
      causeCodeValues: [],
      causeCodeKeyValues: [],
      eventType: this.props.eventTypes.map(d => d.eventType),
      selStations: [],
      stationOption: [],
      choiceUnitStation: 'unit',
      dateSelectionType: 0,
      allCauseCode: true,
      visibleStation: false,

      CLIENT: props.CLIENT,
      effeDate: moment(),
      effeDateStr: moment().format('MM/DD/YYYY'),
      aepAcaReportUnitIds: [],
    }

    // this.utilityOnChange = this.utilityOnChange.bind(this)
    this.monthYeardataCallback = this.monthYeardataCallback.bind(this)
    this.changeReportNanme = this.changeReportName.bind(this)
    // this.onCauseCodeTreeCheckedKeys = this.onCauseCodeTreeCheckedKeys.bind(this)
    this.onCauseCodeTreeCancel = this.onCauseCodeTreeCancel.bind(this)
    this.onCauseCodeDialogClose = this.onCauseCodeDialogClose.bind(this)
    // this.utilityStatonLoad = this.utilityStatonLoad.bind(this)
    this.changeDateSelectionType = this.changeDateSelectionType.bind(this)

    this.getRegionList = this.getRegionList.bind(this)
    // this.setErr = this.setErr.bind(this)
    this.setDateMap = this.setDateMap.bind(this)
    this.getDateMap = this.getDateMap.bind(this)
    this.getRiverListByRegion = this.getRiverListByRegion.bind(this)
    this.getStationByRiver = this.getStationByRiver.bind(this)
  }

  // utilityStatonLoad(stations, utilityStation, selUtility) {
  //   let c = utilityStation || []
  //   c = c[selUtility] || []

  //   return c.map(id => ({
  //     key: id,
  //     value: id,
  //     text: stations[id],
  //   }))
  // }

  monthYeardataCallback(key, data) {
    this.setState({ [key]: { ...this.state[key], ...data } })
  }

  // onCauseCodeTreeCheckedKeys = (causeCodeValues, e) => {
  //   //e.checkedNodes.props
  //   this.setState({
  //     causeCodeValues,
  //   })
  // }

  onCauseCodeTreeCancel = causeCodeKeyValues => {
    this.setState({
      causeCodeKeyValues,
      causeCodeDialogVisible: false,
    })
  }

  // onCauseCodeDialogClose(causeCodeKeyValues, causeCodeValues) {
  //   this.setState({
  //     causeCodeDialogVisible: false,
  //     causeCodeKeyValues,
  //     causeCodeValues,
  //   })
  // }

  onCauseCodeDialogClose = (selectedKeys, selectedValues) => {
    this.setState({
      causeCodeDialogVisible: false,
      causeCodeKeyValues: selectedKeys,
      causeCodeValues: selectedValues,
    })
  }

  // utilityOnChange(value) {
  //   const stationOption = this.utilityStatonLoad(
  //     this.props.stations,
  //     this.props.utilityStation,
  //     value
  //   )

  //   const filteredUnits = unitfilterByUtiltity(value, this.props.units)
  //   this.setState({
  //     selUtility: value,
  //     units: filteredUnits,
  //     stationOption,
  //     selStations: [],
  //   })
  // }
}

const WrappedReportScreen = props => (
  <SpinContext.Consumer>
    {({ spinning, setSpinning }) => (
      <ErrorContext.Consumer>
        {({ error, setError }) => (
          <UnitSelectionContext.Consumer>
            {({ setSelectedUnits }) => (
              <DatePickerContext.Consumer>
                {({
                  selectedDate,
                  setSelectedDate,
                  selectedDateRangePicker,
                  setSelectedDateRagePicker,
                }) => (
                  <JcTmpErrorContext.Consumer>
                    {({ setTmpError }) => (
                      <Report
                        loading={spinning}
                        setLoading={setSpinning}
                        error={error}
                        setError={setError}
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        selectedDateRangePicker={selectedDateRangePicker}
                        setSelectedDateRagePicker={setSelectedDateRagePicker}
                        setTmpError={setTmpError}
                        setSelectedUnits={setSelectedUnits}
                        {...props}
                      />
                    )}
                  </JcTmpErrorContext.Consumer>
                )}
              </DatePickerContext.Consumer>
            )}
          </UnitSelectionContext.Consumer>
        )}
      </ErrorContext.Consumer>
    )}
  </SpinContext.Consumer>
)

export default connect(mapStateToProps, { setDate: setTransDate })(
  WrappedReportScreen
)

// const unitfilterByUtiltity = (utilityId, units) =>
//   units.filter(d => d.utility === utilityId)

// const utilityOption = R.compose(
//   R.map(([key, text]) => ({ key, text: `${key}-${text}`, value: key })),
//   R.sortBy(([key, text]) => text.toLowerCase()),
//   R.toPairs
// )

// const unitOption = units =>
//   units.map(d => ({
//     utility: d.utility,
//     key: d.utility + d.unit,
//     text: `${d.unit}-${d.unitName}`,
//     value: d.unit,
//   }))

// const unitCodeList = R.compose(
//   R.fromPairs,
//   R.map(a => [`${a.utility}${a.unit}`, a.id1])
// )
